import React, { useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";  // Добавлен импорт для кнопки
import { useNavigate } from "react-router-dom";  // Импортируем useNavigate для редиректа
import Type from "./Home/Type";

import homeLogo from "../Assets/home-main.svg";
import newPhoto from "../Assets/home-bg.jpg"; // Путь к новой фотографии

function Auth() {
  
  
  const navigate = useNavigate();  // Создаём хук для навигации
  
  // Функция для обработки клика на кнопку
  const handleButtonClick = () => {
    
    window.location.href = "http://212.109.216.87/mytracker25_site/edited/auth_index.php";
    
  };
  
  useEffect(() => {
    // Извлекаем параметр "hash" из URL
    const urlParams = new URLSearchParams(window.location.search);
    const hash = urlParams.get("hash");
    
    if (hash) {
      

      const sessionData = {
        userId: 'user123',
        token: hash,
      };
      localStorage.setItem('session', JSON.stringify(sessionData)); // Сохраняем
      
      
      
    }
    
    
    
    
  }, []);  // Запускается один раз при монтировании компонента


  
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Шаг{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  1️⃣
                </span>
              </h1>
  
              <h1 className="heading-name">
                I'M
                <strong className="main-name"> Авторизация </strong>
              </h1>
  
              <div style={{ padding: 50, textAlign: "left" }}>
                {/* Типографика (Typewriter Effect) */}
                <Type />
              </div>
  
              {/* Добавление кнопки с редиректом */}
              <div style={{ padding: 50, paddingTop: "20px" }}>
              <Button
                variant="primary"
                size="lg"
                style={{
                  padding: "10px 30px",
                  fontSize: "16px",
                  backgroundColor: "red",  // Проверка
                  zIndex: 9999,  // Убедитесь, что кнопка находится поверх других элементов
                  position: "relative"
                }}
                onClick={handleButtonClick}
              >
                Get Started
              </Button>
              </div>
            </Col>
  
           
          </Row>
        </Container>
      </Container>
  
    </section>
  );
}

export default Auth;
